<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Kế hoạch giảng dạy"
          :link="[
            {
              text: 'Kế hoạch giảng dạy',
              href: '../teachingPlan',
            },
          ]"
        />
      </div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <TeachingPlanFilter @onFilterChanged="onFilterChange" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <TeachingPlanDataTable ref="teachingPlanDataTable" />
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import TeachingPlanDataTable from '@/modules/teachingPlan/TeachingPlanDataTable.vue'
import TeachingPlanFilter from '@/modules/teachingPlan/TeachingPlanFilter.vue'

export default {
  components: {
    Breadcrumbs,
    TeachingPlanDataTable,
    TeachingPlanFilter,
  },

  data() {
    return {}
  },
  computed: {},
  methods: {
    async refresh(query) {
      this.$refs.teachingPlanDataTable.refresh(query)
    },
    onFilterChange(query) {
      this.refresh(query)
    },
  },
}
</script>
<style lang="scss" scoped></style>
